import React from 'react';
import PropTypes from 'prop-types';

import './TitleWithIcon.scss';

function TitleWithIcon({ icon, note, title }) {
  return (
    <div styleName="container">
      <div styleName="main_content">
        <h2 className="avenir_black rem_1_5 tall_lines break_words">{ title }</h2>
        <img styleName="icon" role="presentation" src={icon} />
      </div>

      { (note !== '') ?
        (<p className="heavy_text tealish rem_0_875" styleName="note">{ note }</p>) : null }
    </div>
  );
}

TitleWithIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  note: PropTypes.string,
  title: PropTypes.string.isRequired
};

TitleWithIcon.defaultProps = {
  note: ''
};

export default TitleWithIcon;
